import { Component, OnInit, Input, EventEmitter, Output, ChangeDetectorRef, ViewChild } from '@angular/core';
import { ModalService } from '../services/modal.service';
import * as _ from 'lodash';
import { AppointmentService } from '../services/appointment.service';
import { UserService } from '../services/user.service';
import { TranslatePipe } from '../pipes/translate.pipe';
import { environment } from '@env/environment';
import { PaymentService } from '../services/payment.service';
import { PACKAGELOCATION, POINTSTYPE, visitType } from '@type';
import { HOMECARE, POINTSTYPEDEFAULT } from '../app.const';
import { GoogleTagsService } from '../services/google-tags.service';
import { Observable, Subject } from "rxjs";
import { APPTACTION, APPTFLAGS } from '@type';
import { LinkPatientService } from '../services/link-patient.service';
import { AltpaymentInputComponent } from '../components/altpayment-input/altpayment-input.component';
import { PartitionerDetailsPipe } from '../pipes/partitioner-details.pipe';
import { SpecialityDetailsPipe } from '../pipes/speciality-details.pipe';
import { GeodistancePipe } from '../pipes/geodistance.pipe';
import { PackageService } from '../services/package.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-upcoming-appointment-detail',
  templateUrl: './upcoming-appointment-detail.component.html',
  styleUrls: ['./upcoming-appointment-detail.component.scss'],
  providers: [TranslatePipe, PartitionerDetailsPipe, SpecialityDetailsPipe, GeodistancePipe]
})
export class UpcomingAppointmenDetailComponent implements OnInit {
  @Input() viewAppointment: any;
  @Input() initCheckin: APPTACTION;
  @Input() isCommonView: boolean;
  @Input() modalId: string;
  refresh: Subject<boolean> = new Subject<boolean>();
  refreshFlip: Subject<Object> = new Subject<Object>();
  @Output() reschedule: EventEmitter<any>;
  @Output() expressReschedule: EventEmitter<any>;
  @Output() uploadQuestionnarie: EventEmitter<any>;
  @Output() uploadDocs: EventEmitter<any>;
  @Output() close = new EventEmitter<void>();
  @Output() applyingCode: EventEmitter<any>;
  //private used
  private facility: any;
  private selected_lang: string;
  private practName: any;
  private specName: any;
  private visitType: visitType;
  private paymentGatewayUrl: string;
  private geoDistanceSatisfied: boolean;
  private canFillQuestionnarie: boolean;
  private discountValue;
  private enableQueueOnFacility: boolean = false;
  private getQueueInterval: any;
  private linkedPatients = [];
  private canCancelAppt: boolean = false
  private canRescheduleAppt: boolean = false

  public actionType: APPTACTION
  public visitInfo: boolean = false;
  public primaryActions: Array<any>;
  public isCheckout: boolean;
  public serviceDetails: Array<any>;
  public currency_code: string;
  public homecareService: Array<any>;
  public alreadyPaid: boolean;
  public hasDiscount: boolean = false;
  public isPromoApplied: boolean = false;
  public isEnablePromo: boolean;
  public isEnableCoupon: boolean;
  public isEnablePoints: boolean;
  public freeFollowUpYn: string;
  public canPay: boolean;
  public applyPromoDiscYn: boolean
  public isCouponApplied: boolean = false;
  public payableCharge: number;
  public HOMECARE = HOMECARE;
  public isActionOpen: boolean;
  public checkinResponseData: any;
  public mappingFloorControls: any;
  public mappingFloorInfo: any;
  public triangleArr = [1, 2, 3, 4, 5, 6, 7, 8, 9, 11, 12, 13, 14, 15];
  public promoCodeParam: any;
  public promoAmtForPaidAppt: any;
  public totalCouponBurntAmt: number;
  public totalPointsPaid: number;
  public apptDetails: any;
  public type: string;
  public openMyPackages: boolean = false;
  public packageRefNum: any;
  public openHealthPackageSlot: boolean = false;
  public selectedNewSlot: any;
  public requestInfo: any;
  public healthPkg: any;
  public openPackageRescheduleConfirmReq: boolean = false;
  public apptConfirmDetails: any;
  public openPackageResheduleConfirmationDtl: boolean = false;
  public openingAction:boolean = false;
  public totalServiceCost: any;
  public computedDetail: any = {};
  public apptDetail: any = {};
	recurringCurrentPage =1;
	recurringPageCount =5;
  public disablePayBeforeCheckinTime: boolean;
  public promoCodeParams: any = null;
  @ViewChild('coupon', { static: false }) coupon: AltpaymentInputComponent;
  @ViewChild('points', { static: false }) points: AltpaymentInputComponent;
	public readonly pointsType: POINTSTYPE = POINTSTYPEDEFAULT

  public chargeVatDetails:any;
  public chargeVatInfoRef:any;
  currentView: 'SLOT' | 'CONFIRMREQ' |'CONFIRM' = 'SLOT';
  public isApplyingCode: boolean = false;
  constructor(private modalService: ModalService, private apptService: AppointmentService, private user: UserService, private translatePipe: TranslatePipe, private paymentService: PaymentService, private gtmService: GoogleTagsService, private linkPatient: LinkPatientService, private cdf: ChangeDetectorRef, private pracDetailsPipe: PartitionerDetailsPipe, private specDetailsPipe: SpecialityDetailsPipe, private geodistance: GeodistancePipe, private packageService: PackageService, private router: Router,) {
    this.isCheckout = false
    this.reschedule = new EventEmitter<any>();
    this.expressReschedule = new EventEmitter<any>();
    this.uploadQuestionnarie = new EventEmitter<any>();
    this.uploadDocs = new EventEmitter<any>();
    this.applyingCode = new EventEmitter<any>();
    this.serviceDetails = new Array<any>();
    this.homecareService = new Array<any>();
    this.getUpdatesInfo();
    for (let i = 1; i < 100; i++) {
      this.triangleArr.push(i)
    }
  }

  ngOnInit() {
    console.log('viewappt', this.viewAppointment);
    this.selected_lang = this.user.currentLanguage;
    this.currency_code = this.user.getCurrency() || environment['CURRENCY'];
    if ( this.viewAppointment?.isPackage || this.viewAppointment?.packageInfo || this.viewAppointment?.appointmentType === "PK" || this.viewAppointment?.appointmentType === "PACKAGE") {
      this.viewAppointment._skipVisitCharge = true;
    }
    this.setRequiredParam()
    this.preProcessScheduleFlags();
    if(this.viewAppointment?.isPackage) {
      this.user.getUserId().subscribe(data => {
        console.log('getUserId', data);
      if (!data)
        return;
      this.linkPatient.getLinkedPatient(data).subscribe(result => {
        if (result.status === 'SUCCESS') {
          this.linkedPatients = result.data;
          console.log("this.linkedPatients->>", this.linkedPatients)
          var patientDetails = result?.['data']?.find(p => p['uhid'] == this.viewAppointment?.patientId);
          this.viewAppointment = {
            patientId: this.viewAppointment?.patientId,
            patientName: this.viewAppointment?.personName,
            packageDetails: this.viewAppointment?.packageInfo?.packageDetails,
            facilityId: this.viewAppointment?.facilityId,
            apptDateTime: this.viewAppointment?.appointmentDateTime,
            paymentStatus: this.viewAppointment?.paymentDetail?.status,
            apptRefNumber: this.viewAppointment.appointmentId,
            confirmReq: true,
            ...this.viewAppointment,
            patientDetails: patientDetails
            }
          }
            })
            this.type = 'CONFIRMPACKAGE';
            console.log('CONFIRMPACKAGE',  this.viewAppointment);
      });
    } else {
      this.viewAppointment = this.viewAppointment;
    }
  }
  private getUpdatesInfo() {
    this.user.getConfigurationInfo.subscribe(data => {
      this.isEnablePromo = data['pxAppSettings']['enablePromoYn'] == 'Y' ? true : false;
      this.isEnableCoupon = data['pxAppSettings']['enableCouponYn'] == 'Y' ? true : false;
      this.isEnablePoints = data['pxAppSettings']['enablePointsYn'] == 'Y' ? true : false;
      this.paymentGatewayUrl = data.features['paymentGateway']['paymentGatewayUrl'];
    })
  }

  public redirectToPackage(event) {
    this.openMyPackages = true;
    this.packageRefNum = event?.appointmentId
  }

  public closeMyPackages() {
    this.openMyPackages = false;
    this.close.emit();
  }

	private preProcessScheduleFlags(openActions: boolean = false) {
		if (this.openingAction) return;
		this.openingAction = true;
		this.getSubscribedPackageData().subscribe(_ => {
			this.processScheduleFlags()
			if (openActions) {
				this.presentAppointmentActions();
			} else {
				this.openingAction = false
			}
			
		})
    this.postProcess()
	}

	private getSubscribedPackageData(): Observable<any> {
		return new Observable(observer => {
			if (!this.viewAppointment.packageInfo || this.viewAppointment.subscribedPackageData) {
				observer.next(true);
				return
			}
			this.packageService.getPackageForAppt(this.viewAppointment).subscribe(data => {
				this.viewAppointment.subscribedPackageData = data.packageUtilisation
				observer.next(true);
			}, err => {
				observer.next(true);
			})
		})
	}

  private processScheduleFlags(recheckActions:boolean = false) {
    console.info("=== viewAppointment ===", this.viewAppointment)
    if (this.viewAppointment.chargeDetails && this.viewAppointment.chargeDetails.disableCoupon) {
      this.isEnableCoupon = false
    }
    if (this.viewAppointment.chargeDetails && this.viewAppointment.chargeDetails.disablePoints) {
      this.isEnablePoints = false
    }
    if (this.viewAppointment.chargeDetails && !recheckActions) {
      this.viewAppointment.chargeDetails.discountedPayable = this.viewAppointment.chargeDetails.totalAmount
      this.calculatePayable()
    }
    this.chargeVatInfoRef=_.cloneDeep(this.viewAppointment.chargeDetails.parsedCharge);
    if(this.viewAppointment.chargeDetails && this.viewAppointment.chargeDetails.parsedCharge){
      this.calculateVatCharges(this.viewAppointment.chargeDetails.parsedCharge);
    }
    const recievedFlags: APPTFLAGS = this.apptService.processScheduleFlag(this.viewAppointment, 'PREVIEW');
    console.log("=== recievedFlags ====", recievedFlags)
    const mappedFlag: APPTFLAGS = {
      canCancelAppt: recievedFlags.canCancelAppt,
      canRescheduleAppt: recievedFlags.canRescheduleAppt,
      canCheckInVC: recievedFlags.canCheckInVC,
      canCheckInIP: recievedFlags.canCheckInIP,
      actionType: recievedFlags.actionType,
      checkinStatus: recievedFlags.checkinStatus,
      canRejoin: recievedFlags.canRejoin,
      canFilterApptAfterPolicyTime: recievedFlags.canFilterApptAfterPolicyTime
    }
    this.canCancelAppt = mappedFlag.canCancelAppt;
    this.canRescheduleAppt = mappedFlag.canRescheduleAppt;
    if (this.viewAppointment.appointmentType == 'VIDEO') {
      this.actionType = mappedFlag.actionType;
    } else {
      this.actionType = mappedFlag.actionType;
    }
    this.presentAppointmentActions();
  }
  private async presentAppointmentActions() {
    let buttons = [
      {
        text: this.translatePipe.transform('appt_but_pay'),
        icon: './assets/icons/Appointments/check in.svg',
        enable: this.actionType == 'PAY',
        actionType: 'PAY',
        cssClass: 'primary-action',
        handler: () => {
          this.handleActions('onlyPay', null);
        }
      },
      {
        text: this.translatePipe.transform('cal_modal_btn_pay_and_checkin'),
        icon: './assets/icons/Appointments/check in.svg',
        enable: this.actionType == 'PAYCHECKIN',
        actionType: 'PAYCHECKIN',
        cssClass: 'primary-action',
        handler: () => {
          if (this.visitType == 'VIDEO') this.handleActions('payCheckinVC', null);
          else this.handleActions('payCheckinIV', null);
        }
      },
      {
        text: this.translatePipe.transform('cal_modal_btn_checkin'),
        icon: './assets/icons/Appointments/check in.svg',
        enable: this.actionType == 'CHECKIN',
        actionType: 'CHECKIN',
        cssClass: 'primary-action',
        handler: () => {
          if (this.visitType == 'VIDEO') this.handleActions('checkinVC', null)
          else this.handleActions('checkinIV', null)
        }
      },
      {
        text: this.translatePipe.transform('APPTPREVIEW#ACTIONSHEET#LABEL#FILLQUES'),
        icon: './assets/icons/Appointments/questionnaire.svg',
        enable: this.canFillQuestionnarie,
        handler: () => {
          console.log('FILLQUES clicked');
          this.openQuestionnarie();
        },
        isRight: true
      },
      {
        text: this.translatePipe.transform('APPTPREVIEW#ACTIONSHEET#LABEL#UPLOADDOCS'),
        icon: './assets/icons/Appointments/upload.svg',
        enable: this.viewAppointment.appointmentType == 'VIDEO',
        handler: () => {
          console.log('FILLQUES clicked');
          this.openUploadDocs();
        }
      },
      {
        text: this.translatePipe.transform('APPTPREVIEW#ACTIONSHEET#LABEL#CANCEL'),
        icon: './assets/icons/Appointments/cancel appt.svg',
        enable: this.canCancelAppt,
        handler: () => {
          console.log('CANCEL clicked');
          this.initCancelAppointment();
        }
      },
      {
        text: this.translatePipe.transform('APPTPREVIEW#ACTIONSHEET#LABEL#RESCHEDULE'),
        icon: './assets/icons/Appointments/reschedule.svg',
        enable: this.canRescheduleAppt,
        handler: () => {
          console.log('RESCHEDULE clicked');
          this.rescheduleVisit();
        }
      }
    ];

    buttons = buttons.filter((b) => b.enable)
    console.log("====== btns", buttons)
    buttons.forEach(b => {
      if (b.text === this.translatePipe.transform('cal_modal_btn_checkin') &&
        !_.isEmpty(this.viewAppointment['consultationStatus'])) {
        b.text = this.translatePipe.transform('cal_modal_btn_join');
      }
    })
    console.log("this.primaryActions", this.primaryActions)
    this.primaryActions = buttons;
    if (this.initCheckin) {
      const handler = this.primaryActions.find(h => h.actionType == this.initCheckin)
      if(handler) handler.handler()
    }
  }
  public closeModal(id: string) {
    console.log("---- upcoming appt modalId---", id, this.modalId)
    if (this.modalId) {
      console.log("this.modalId", this.modalId)
      this.modalService.close(this.modalId);
    }
    else {
      console.log("id", id)
      this.modalService.close(id);
      this.visitInfo = false;
    }
  }
  private handleActions(event: 'checkinVC' | 'checkinIV' | 'onlyPay' | 'payCheckinVC' | 'payCheckinIV', data) {
    console.log('checkin event->', event);
    switch (event) {
      case 'checkinVC':
        this.checkinVC();
        break;
      case 'checkinIV':
        this.checkinIV();
        break;
      case 'onlyPay':
        this.initPay('PAY');
        break;
      case 'payCheckinVC':
        this.initPay('checkinVC');
        break;
      case 'payCheckinIV':
        if (!this.viewAppointment.chargeDetails.netPayable) {
          this.checkinIV()
        } else {
          this.initPay('checkinIV');
        }
        break;
    }
  }

  private handleCallBack(callback, close) {
    switch (callback) {
      case 'checkinVC':
        this.checkinVC()
        break;
      default:
        this.closeModal('calendar-appointment-details-modal')
    }
  }
  private checkinVC() {
    this.closetc(true);
  }
  private checkinIV() {
    if (this.facility.facilityControls?.schedulingRules?.checkInPolicy?.restrictions?.geolocation)
      var geoRestriction = this.facility.facilityControls.schedulingRules.checkInPolicy.restrictions.geolocation;
    console.log('satisfy', geoRestriction, this.geoDistanceSatisfied, this.viewAppointment.discount)
    if (!geoRestriction || (geoRestriction?.enabled && this.geoDistanceSatisfied) || !geoRestriction.enabled) {
      const selectedAppointment = this.viewAppointment

      let payload = {
      personId: this.user.getPersonId(),
      patientPersonId: selectedAppointment.personId,
      patientId: selectedAppointment.uhid,
      facilityId: selectedAppointment.facilityId,
      apptRefNumber: selectedAppointment.appointmentId,
      clinicCode: selectedAppointment.clinicCode,
      localeCode: this.user.getCurrentLanguage(),
      patientName: selectedAppointment.personName,
      practitionerName: this.translatePipe.transform(this.practName, 'LOCALE', 'name'),
      specialityName: this.translatePipe.transform(this.specName, 'LOCALE', 'name'),
      transactionNo: selectedAppointment.transactionNo,
      gatewayRefNo: selectedAppointment.paymentDetail.reference,
      discount: selectedAppointment.discount,
      locale: this.user.getCurrentLanguage(),
    }
    if (!selectedAppointment._skipVisitCharge && selectedAppointment.chargeDetails) {

      if (selectedAppointment.chargeDetails.freeFollowUpYn === 'Y') {
        payload['freeFollowUpYn'] = selectedAppointment.chargeDetails.freeFollowUpYn;
      }

      if (selectedAppointment.chargeDetails.billingGroupCode) {
        payload['billingGroupCode'] = selectedAppointment.chargeDetails.billingGroupCode;
      }

    }
    if (selectedAppointment.chargeDetails.insuranceFinDtls) {
      payload['insuranceFinDtls'] = selectedAppointment.chargeDetails.insuranceFinDtls;
      payload['isInsurancePatient'] = true;
    }

    if(selectedAppointment.chargeDetails.isPromoApplied){
      payload['appliedPromoCodes'] = selectedAppointment.chargeDetails.appliedpromocodedtls
      payload['discountType']= "A"
      payload['discount'] = selectedAppointment.chargeDetails.promoDiscount,
      payload['isPromoCodeAppliedYn'] = 'Y'
    }else{
      payload['isPromoCodeAppliedYn'] = 'N'
    }
    if(selectedAppointment['promoCodeAppliedYn'] == 'Y') {
      payload['appliedPromoCodes'] = selectedAppointment.promoDetails
      payload['discountType']= "A"
      payload['discount'] = selectedAppointment.promoDiscountedAmt,
      payload['isPromoCodeAppliedYn'] = 'Y'
    }
    if(selectedAppointment.chargeDetails.isCouponApplied){
      payload['coupons'] = selectedAppointment.chargeDetails.appliedcouponcodedtls
      payload['holdCoupon'] = true
    }
    if(selectedAppointment.chargeDetails.isPointsApplied){
      payload['appliedPoints'] = selectedAppointment.chargeDetails.appliedPoints
      payload['holdPoints'] = true
    }

    if(selectedAppointment['dermaServiceApptToAvail']){
      payload['dermaServiceApptToAvail']=true;
    }

    console.info('params',payload)


      // let payload = {
      //   personId: this.user.getPersonId(),
      //   patientPersonId: selectedAppointment.personId,
      //   patientId: selectedAppointment.uhid,
      //   facilityId: selectedAppointment.facilityId,
      //   apptRefNumber: selectedAppointment.appointmentId,
      //   clinicCode: selectedAppointment.clinicCode,
      //   localeCode: this.user.getCurrentLanguage(),
      //   patientName: selectedAppointment.personName,
      //   practitionerName: this.translatePipe.transform(this.practName, 'LOCALE', 'name'),
      //   specialityName: this.translatePipe.transform(this.specName, 'LOCALE', 'name'),
      //   transactionNo: selectedAppointment.transactionNo,
      //   gatewayRefNo: selectedAppointment.paymentDetail.reference,
      //   discount: selectedAppointment.discount
      // }
      // if (selectedAppointment.chargeDetails.freeFollowUpYn == 'Y') payload['freeFollowUpYn'] = selectedAppointment.chargeDetails.freeFollowUpYn;

      // if (selectedAppointment.chargeDetails.billingGroupCode) payload['billingGroupCode'] = selectedAppointment.chargeDetails.billingGroupCode
      // if (selectedAppointment.chargeDetails.insuranceFinDtls) {
      //   payload['insuranceFinDtls'] = selectedAppointment.chargeDetails.insuranceFinDtls;
      //   payload['isInsurancePatient'] = true;
      // }

      // if (selectedAppointment.chargeDetails.isPromoApplied) {
      //   payload['appliedPromoCodes'] = selectedAppointment.chargeDetails.appliedpromocodedtls
      //   payload['discountType'] = "A"
      //   payload['discount'] = selectedAppointment.chargeDetails.promoDiscount,
      //     payload['isPromoCodeAppliedYn'] = 'Y'
      // } else {
      //   payload['isPromoCodeAppliedYn'] = 'N'
      // }
      // if (selectedAppointment.chargeDetails.isCouponApplied) {
      //   payload['coupons'] = selectedAppointment.chargeDetails.appliedcouponcodedtls
      //   payload['holdCoupon'] = true
      // }
      // if (selectedAppointment.chargeDetails.isPointsApplied) {
      //   payload['appliedPoints'] = selectedAppointment.chargeDetails.appliedPoints
      //   payload['holdPoints'] = true
      // }
      this.apptService.checkInAppt(payload).subscribe(response => {
        this.visitInfo = true;
        this.checkinResponseData = response;
        console.log("this.checkinResponseData", this.checkinResponseData)
        if (this.checkinResponseData && this.checkinResponseData.mappingFloorControls) {
          this.mappingFloorControls = this.checkinResponseData.mappingFloorControls;
        }
        if (this.checkinResponseData && this.checkinResponseData.mappingFloorInfo) {
          let info = this.checkinResponseData.mappingFloorInfo;
          this.mappingFloorInfo = {
            floor: info.floor,
            waitingArea: info.waitingArea,
            room: info.room
          }
        }

        console.log("this.mappingFloorInfo", this.mappingFloorInfo);
        if (this.enableQueueOnFacility) {
          console.log("enableQueueOnFacility", this.enableQueueOnFacility)
          if (!this.checkinResponseData['queueNo']) {
            console.log("this.checkinResponseData['queueNo']", !this.checkinResponseData['queueNo'])
            let tmpCount = 0;
            this.getQueueInterval = setInterval(() => {
              console.log('tmpcount====', tmpCount)
              if (tmpCount < 3 && !this.checkinResponseData['queueNo']) {
                console.log("inside test", (tmpCount < 3 && !this.checkinResponseData['queueNo']))
                this.getQueueNo('CHECKIN')
                tmpCount++;
              } else {
                console.log("else")
                clearInterval(this.getQueueInterval)
              }
            }, 2000)
          }
        }

      })
    }
  }
  private initPay(callback) {
    var payload = {
      personId: this.user.getPersonId(),
      linkedPersonId: this.viewAppointment['personid'],
      patientId: this.viewAppointment['uhid'],
      amount: this.user.fixDecimalPlaces(Number(this.viewAppointment.chargeDetails.netPayable)),
      currency: this.currency_code,
      episodeType: 'R',
      encounterId: '0',
      facilityId: this.viewAppointment.facilityId,
      requestType: this.viewAppointment.appointmentType == 'VIDEO' ? 'APTPAYMENT' : ((callback && (callback == 'PAY')) ? 'APTPAYMENT' : 'CHECKIN')
    };
    const selectedAppointment = this.viewAppointment
    let request = {
      personId: this.user.getPersonId(),
      patientPersonId: selectedAppointment.personId,
      patientId: selectedAppointment.uhid,
      facilityId: selectedAppointment.facilityId,
      apptRefNumber: selectedAppointment.appointmentId,
      clinicCode: selectedAppointment.clinicCode,
      localeCode: this.user.getCurrentLanguage(),
      patientName: selectedAppointment.personName,
      practitionerName: this.translatePipe.transform(this.practName, 'LOCALE', 'name'),
      specialityName: this.translatePipe.transform(this.specName, 'LOCALE', 'name'),
      isPromoCodeAppliedYn: selectedAppointment.chargeDetails.isPromoApplied ? 'Y' : 'N',
      isCouponAppliedYn: selectedAppointment.chargeDetails.isCouponApplied ? 'Y' : 'N',
      isPointsAppliedYn: selectedAppointment.chargeDetails.isPointsApplied ? 'Y' : 'N',
      coupons: selectedAppointment.chargeDetails.isCouponApplied ? selectedAppointment.chargeDetails.appliedcouponcodedtls : null,
      appliedPromoCodes: selectedAppointment.chargeDetails.isPromoApplied ? selectedAppointment.chargeDetails.appliedpromocodedtls : null,
      appliedPoints: selectedAppointment.chargeDetails.isPointsApplied ? selectedAppointment.chargeDetails.appliedPoints : null,
      billingGroupCode: selectedAppointment.chargeDetails.billingGroupCode ? selectedAppointment.chargeDetails.billingGroupCode : null,
      insuranceFinDtls: selectedAppointment.chargeDetails.insuranceFinDtls ? selectedAppointment.chargeDetails.insuranceFinDtls : null,
      isInsurancePatient: selectedAppointment.chargeDetails.insuranceFinDtls ? true : false,
      patientPayableAmount: this.user.fixDecimalPlaces(Number(selectedAppointment.chargeDetails.netPayable)),
      visitType: selectedAppointment.appointmentType
    };
    if (selectedAppointment?.chargeDetails?.netPayable == 0) {
      this.apptService.handleAlternatePayments(payload, request).subscribe(data => {
        this.handleCallBack(callback, true)
      })
    } else {
      this.apptService.startTransaction(payload, request).subscribe((response: any) => {
        let appointment = {
          _orderId: response['transaction_id'],
          saved_card_token: response['saved_card_token'],
          saved_card_details: response['savedCards'] && response['savedCards'].length ? response['savedCards'].map(c => c['cardsInfo']) : [],
          saved_stc_details: response['savedSTCNumber'] && response['savedSTCNumber'].length ? response['savedSTCNumber'].map(c => c['cardsInfo']) : [],
          uhid: this.viewAppointment['uhid'],
          email: this.viewAppointment['email'] || environment.DEFAULT_EMAIL,
          mobile_no: ''
        }
        let url = window['location'];
        let params = `apptRefNumber=${this.viewAppointment.appointmentId}&callback=${callback}`
        let diff = (href, origin) => href.split(origin).join('');
        let returnURL = diff(url['href'].split('?')[0], url['origin'] + '/') + `?s=1&method=APTPAYMENT&p=${btoa(params)}`;
        let paymentInfo = {
          _returnURL: returnURL,
          currency: this.user.getCurrencyForPayment() || this.currency_code,
          charge: this.user.fixDecimalPlaces(Number(this.viewAppointment.chargeDetails.netPayable)),
          paymentgatewayurl: this.paymentGatewayUrl
        }
        console.log(paymentInfo);
        this.paymentService.setPaymentParams(appointment, paymentInfo).subscribe(_ => {
          this.showCheckout();
        })
      });
    }
  }
  private showCheckout() {
    this.isCheckout = true;
  }
  private initCancelAppointment() {
    if (this.viewAppointment.packageInfo && this.viewAppointment.checkedIn) {
      this.confirmCancelPackage()
    } else {
      this.confirmCancelAppt();
    }
  }
  private confirmCancelPackage() {
    let payload = {
      resourceId: this.viewAppointment.resourceId,
      patientPersonId: this.viewAppointment.personId,
      uhid: this.viewAppointment.uhid,
      facilityId: this.viewAppointment.facilityId,
      clinicCode: this.viewAppointment.clinicCode,
      appointmentNumber: this.viewAppointment.appointmentId,
      practitionerName: this.translatePipe.transform(this.practName, 'LOCALE', 'name'),
      specialityName: this.translatePipe.transform(this.specName, 'LOCALE', 'name'),
      patientName: this.viewAppointment.personName,
      packageInfo: this.viewAppointment.packageInfo,
      subscriptionInfo: this.viewAppointment.subscribedPackageData,
      encounterId: this.viewAppointment.visitId
    };
    if (!payload.encounterId && (this.viewAppointment.visitStatus && this.viewAppointment.visitStatus.encounterId)) {
      payload.encounterId = this.viewAppointment.visitStatus.encounterId
    }
    this.apptService.initCancelPackage(payload).subscribe((data) => {
      this.closeModal('calendar-appointment-details-modal');
    });
  }
  private confirmCancelAppt(isAllAppts?) {
    let payload = {
      resourceId: this.viewAppointment.resourceId,
      patientPersonId: this.viewAppointment.personId,
      uhid: this.viewAppointment.uhid,
      facilityId: this.viewAppointment.facilityId,
      clinicCode: this.viewAppointment.clinicCode,
      appointmentNumber: this.viewAppointment.appointmentId,
      practitionerName: this.translatePipe.transform(this.practName, 'LOCALE', 'name'),
      specialityName: this.translatePipe.transform(this.specName, 'LOCALE', 'name'),
      patientName: this.viewAppointment.personName
    };
    if (this.viewAppointment.appointmentType == 'HC') {
      let cancelPayload = {
        facilityId: this.viewAppointment.facilityId,
        appointmentId: this.viewAppointment.appointmentId,
        patientId: this.viewAppointment.uhid
      }
      if (isAllAppts && this.viewAppointment['recurringYn'] == 'Y') {
        cancelPayload['isRecurringAppt'] = true;
        cancelPayload['recurringAppointments'] = this.viewAppointment?.['appointments']?.map(ele => ele.appointmentId);
      }
      this.apptService.initHCCancelAppt(cancelPayload).subscribe((data) => {
        this.closeModal('calendar-appointment-details-modal');
      });
    } else {
      this.apptService.cancelAppt(payload).subscribe((data) => {
        this.closeModal('calendar-appointment-details-modal');
      });
    }
  }
  private rescheduleVisit() {
    console.log('rescheduleVisit click', this.viewAppointment, 'serviceDetails', this.serviceDetails);
    if (this.serviceDetails.length)
      this.expressReschedule.emit(this.viewAppointment);
    else if(this.viewAppointment?.isPackage) {
      this.handlePackageNavigation()
    } else {
      this.reschedule.emit(this.viewAppointment);
    }
  }
  private openQuestionnarie(event?) {
    this.uploadQuestionnarie.emit(this.viewAppointment);
  }
  private closetc(status: boolean) {
    if (status) {
      if (!this.selected_lang) this.selected_lang = 'en';
      this.user.openLocation(this.viewAppointment['joinUrl'] + "&source=px&lan=" + this.selected_lang);
      this.closeModal('calendar-appointment-details-modal');
    }
  }
  private openUploadDocs() {
    this.uploadDocs.emit(this.viewAppointment);
  }
  private getQueueNo(type) {
    console.log("checkinResponseData", this.checkinResponseData)

    let param = {
      facilityID: this.viewAppointment.facilityId,
      patientId: this.viewAppointment.patientId,
      encounterId: type == 'CHECKIN' ? this.checkinResponseData['encounterId'] : this.viewAppointment.visitId,
      apptRefnumb: this.viewAppointment.appointmentId
    }
    this.apptService.getQueue(param).subscribe((data) => {
      if (data) {
        if (type == 'CHECKIN') {
          this.checkinResponseData['queueNo'] = data;
        } else this.viewAppointment['queueNo'] = data;
      }
    }, err => {
      
    })
  }

  public getFloorName(data) {
    return data[this.user.getCurrentLanguage()]
  }
  public getServiceName(data) {
    console.log("getServiceName", data)
    let names = data['localNames'] ? data['localNames']['names'] : null;
    if (!names || names.length == 0) {
      return data ? data.desc : '';
    } else {
      let t = names.find(name => {
        return name.locale == this.user.currentLanguage
      })
      if (t) {
        return t.name;
      } else {
        return names[0].name;
      }
    }
  }
  public checkIsNaN(num) {
    return isNaN(num);
  }
  public showAction() {
    this.isActionOpen = !this.isActionOpen
  }

  //Promo coupon

  public pointsApplied(event) {
    if (event.type == 'APPLY') {
      this.viewAppointment.chargeDetails.pointsData = {}
      this.applyPoints(event.data)
    } else if (event.type == 'REMOVE') {
      this.removePoints()
    }
  }
  public applyingPoints(event) {
    this.setIsApplyingCode(event.status)
  }
  public applyingPromoCode(event) {
    this.setIsApplyingCode(event.status)
  }
  public applyingCouponCode(event) {
    this.setIsApplyingCode(event.status)
  }

  private setIsApplyingCode(val) {
    this.isApplyingCode = val;
    this.applyingCode.emit({ status: val });
  }

  public appliedPromocode(event) {
    if (event.type == 'APPLY') {
      this.applyDiscount(event.data)
    } else if (event.type == 'REMOVE') {
      this.removeDiscounts();
    }
  }
  public couponApplied(event) {
    if (event.type == 'APPLY') {
      this.viewAppointment.chargeDetails.couponTitle = []
      this.applyCouponcode(event.data)
    } else if (event.type == 'REMOVE') {
      this.removeCouponCode()
    }
  }

  private applyDiscount(response) {
    this.viewAppointment.chargeDetails.appliedpromocodedtls = response.appliedpromocodedtls;
    this.viewAppointment.chargeDetails.promoDiscount = Number(response.calculatedDiscountAmt);
    this.viewAppointment.chargeDetails.netPayable = Number(response.netservicecharge)
    this.viewAppointment.chargeDetails.discountedPayable = Number(response.netservicecharge)
    this.viewAppointment.chargeDetails.isPromoApplied = response.appliedpromocodedtls?.length > 0;
    if(response.netchargedtls && response.netchargedtls.length>0){
      this.chargeVatDetails['vatDisplayAmount']=this.calculateVatDisplayAmount(response.netchargedtls[0].taxAmount,response.netchargedtls[0].taxExemptAmount);
    }
    if (response.pointsApplied) {
      this.applyPoints({ pointsDerivative: response.pointsApplied })
    } else {
      this.removePoints()
    }
    this.handlePostDiscount()
  }

  public removeDiscounts() {
    this.setIsApplyingCode(true)
    this.viewAppointment.chargeDetails.netPayable = Number(this.viewAppointment.chargeDetails.totalAmount)
    this.viewAppointment.chargeDetails.discountedPayable = Number(this.viewAppointment.chargeDetails.totalAmount)
    this.viewAppointment.chargeDetails.isPromoApplied = false;
    this.viewAppointment.chargeDetails.promoDiscount = 0;
    this.removePoints()
    this.handlePostDiscount()
  }
  
  private handlePostDiscount() {
    let isCouponHandled = this.coupon && this.viewAppointment.chargeDetails.isCouponApplied
    let isPointsHandled = this.points && this.viewAppointment.chargeDetails.isPointsApplied && this.pointsType == 'PAYMENT'

    if (isCouponHandled || isPointsHandled) {
      if (isCouponHandled) this.coupon.removeAllCoupons(true);
      if (isPointsHandled) this.points.removeAllPoints(!isCouponHandled);
    } else {
      this.calculatePayable()
    }
  }

  private applyCouponcode(response) {
    this.viewAppointment.chargeDetails.appliedcouponcodedtls = response.appliedcouponcodedtls;
    this.viewAppointment.chargeDetails.couponTitle = this.viewAppointment.chargeDetails.appliedcouponcodedtls.map(item => item.couponTitle)
    this.viewAppointment.chargeDetails.couponDiscount = Number(response.value);
    this.viewAppointment.chargeDetails.isCouponApplied = response.appliedcouponcodedtls.length > 0;
    this.calculatePayable(true)
  }
  private removeCouponCode() {
    this.viewAppointment.chargeDetails.appliedcouponcodedtls = null
    this.viewAppointment.chargeDetails.couponTitle = []
    this.viewAppointment.chargeDetails.isCouponApplied = false;
    this.viewAppointment.chargeDetails.couponDiscount = 0;
    this.calculatePayable(true)
  }
  private applyPoints(response) {
    console.log('applypoints', response)
    this.viewAppointment.chargeDetails.appliedPoints = response.pointsDerivative;
    this.viewAppointment.chargeDetails.pointsDiscount = Number(response.pointsDerivative.amount);
    this.viewAppointment.chargeDetails.isPointsApplied = this.viewAppointment.chargeDetails.pointsDiscount > 0
    if(this.pointsType == 'PAYMENT')
    this.calculatePayable(true)
  }
  private removePoints() {
    this.viewAppointment.chargeDetails.appliedPoints = null;
    this.viewAppointment.chargeDetails.pointsDiscount = 0;
    this.viewAppointment.chargeDetails.isPointsApplied = false;
    if (this.pointsType == 'PAYMENT')
    this.calculatePayable(true)
    this.calculateVatCharges(this.chargeVatInfoRef);
  }
  private calculatePayable(recheckActions:boolean = false) {
    let couponDiscount = this.viewAppointment.chargeDetails.couponDiscount || 0;
    let pointsDiscount = this.pointsType == 'PAYMENT' ? (this.viewAppointment.chargeDetails.pointsDiscount || 0) : 0;

    this.viewAppointment.chargeDetails.netPayable = this.viewAppointment.chargeDetails.discountedPayable - couponDiscount - pointsDiscount;
    this.viewAppointment.chargeDetails._payableWithoutCoupon = this.viewAppointment.chargeDetails.netPayable + couponDiscount;
    this.viewAppointment.chargeDetails._payableWithoutPoints = this.viewAppointment.chargeDetails.netPayable + pointsDiscount;
    this.resetPaymentFlow(recheckActions)
    console.log('calculatePayable', this.viewAppointment)
  }
  private resetPaymentFlow(recheckActions: boolean = false) {
    if (Number(this.viewAppointment.chargeDetails.netPayable) <= 0) {
      this.viewAppointment.chargeDetails.netPayable = 0;
    } else {

    }
    this.viewAppointment.chargeDetails.netPayable = this.user.fixDecimalPlaces(Number(this.viewAppointment.chargeDetails.netPayable));
    this.viewAppointment.chargeDetails = _.cloneDeep(this.viewAppointment.chargeDetails)
    if (recheckActions) {
      this.processScheduleFlags(recheckActions)
    }
    setTimeout(_ => {
      this.setIsApplyingCode(false)
      this.cdf.detectChanges();
    }, 500)
  }
  private setRequiredParam() {
    this.facility = this.user.findFacility(this.viewAppointment['facilityId']);
    this.visitType = this.viewAppointment['appointmentType'];
    this.practName = this.pracDetailsPipe.transform(this.viewAppointment.resourceId, this.viewAppointment['facilityId'], 'resourceName');
    let specId = this.pracDetailsPipe.transform(this.viewAppointment.resourceId, this.viewAppointment['facilityId'], 'specialityId');
    this.specName = this.specDetailsPipe.transform(specId, this.viewAppointment['facilityId'], 'specialityName');
    this.canFillQuestionnarie = this.viewAppointment['_state'] == 'UPCOMING' && this.viewAppointment.appointmentType == 'VIDEO' && (!this.viewAppointment.consultationStatus || (this.viewAppointment.consultationStatus && this.viewAppointment.consultationStatus != 'FINISH' && this.viewAppointment.consultationStatus != 'CANCEL'))
    if (this.facility) {
      if (this.facility.facilityControls && this.facility.facilityControls.schedulingRules && this.facility.facilityControls.schedulingRules.others && this.facility.facilityControls.schedulingRules.others.showQueueNo
        && this.facility.facilityControls.schedulingRules.others.showQueueNo == 'Y') {
        this.enableQueueOnFacility = true;
        if (this.viewAppointment && this.viewAppointment['checkedIn'] == "true" && !this.viewAppointment['queueNo']) {
          this.getQueueNo('APPT')
        }
      } else {
        this.enableQueueOnFacility = false;
      }
    }
    this.isWithinGeoRange();
    if (this.viewAppointment['homeCareServices']) {
      if (this.viewAppointment?.homeCareServices?.homeCareServices?.length) { 
        this.homecareService = this.viewAppointment['homeCareServices']['homeCareServices']
      }
      if (this.viewAppointment['homeCareServices']['paymentMode']) {
        this.viewAppointment['_apptMode'] = this.viewAppointment['homeCareServices']['paymentMode']['code']
      }
    }
    if (this.viewAppointment['paymentDetail']['status'] == 'PAID') {
      this.alreadyPaid = true;
      this.discountValue = Number(this.viewAppointment['discount'])
      if (this.viewAppointment?.couponDetails?.couponAmount?.length) {
        this.totalCouponBurntAmt = this.viewAppointment['couponDetails']['couponAmount'].map(element => element).reduce((prev, next) => parseFloat(Number(prev).toFixed(2)) + parseFloat(Number(next).toFixed(2)));
      }
      if (this.viewAppointment['promoCodeAppliedYn'] == 'Y' && this.viewAppointment['promoDetails']) {
        this.promoAmtForPaidAppt = this.viewAppointment['promoDetails'][0]['calculatedDiscountAmt']
      }
      this.totalPointsPaid = this.viewAppointment?.couponDetails?.pointsAmount || null
      if (this.viewAppointment && this.viewAppointment.billLevelDiscountAmt) {
        this.viewAppointment['discount'] += Number(this.viewAppointment.billLevelDiscountAmt);
      }
    }
    if (this.viewAppointment['appointmentType'] && this.viewAppointment['appointmentType'] == 'CLINIC') {
      let services = this.viewAppointment['resourceDetail'] ? this.viewAppointment['resourceDetail']['servicesToOrder'] : null
      if (services && services.length > 0) {
        services.forEach(data => {
          let concepts = data['concepts'];
          concepts.map(concept => {
            this.serviceDetails.push(concept);
          })
        })
      }
    }
    this.promoCodeParam = {
      facility: {
        id: this.viewAppointment.facilityId
      },
      patient: {
        id: this.viewAppointment.uhid
      },
      practitioner: {
        id: this.viewAppointment.resourceId
      }
    }
  }
  private isWithinGeoRange() {
    this.user.getGeoLocation().subscribe(res => {
      console.log('location data=------', res)
      if (res.status) {
        let data = res.data;
        let latlon = data;
        if (latlon) {
          if (this.facility.facilityControls.schedulingRules.checkInPolicy && this.facility.facilityControls.schedulingRules.checkInPolicy.restrictions && this.facility.facilityControls.schedulingRules.checkInPolicy.restrictions.geolocation) {
            let geoRestriction = this.facility.facilityControls.schedulingRules.checkInPolicy.restrictions.geolocation;
            console.log("isWithinGeoRange", geoRestriction.enabled)
            if (geoRestriction.enabled) {
              let faclatlon = this.facility.facilityGeoLocation;
              let distance = this.geodistance.transform(faclatlon, latlon['lat'], latlon['lon']);
              if (geoRestriction.unit == 'm') {
                distance = distance * 1000;
              }
              if (distance <= geoRestriction.distance) {
                this.geoDistanceSatisfied = true;
                console.log("getGeoLocation data", this.geoDistanceSatisfied)
              } else {
                this.geoDistanceSatisfied = false;
                console.log("getGeoLocation data", this.geoDistanceSatisfied)
              }
            } else {
              this.geoDistanceSatisfied = true;
            }
          } else {
            this.geoDistanceSatisfied = true;
            console.log("getGeoLocation data", this.geoDistanceSatisfied)
          }
        }
      }
    })
    return false;
  }

  private calculateVatCharges(parsedCharge){
    let chargeVatDetails = parsedCharge;
    chargeVatDetails['vatDisplayAmount']=this.calculateVatDisplayAmount(chargeVatDetails.vatAmount,chargeVatDetails.vatExemptedAmt)
    this.chargeVatDetails=chargeVatDetails;
    console.info('chargeVatDetails',this.chargeVatDetails)
  }

  private calculateVatDisplayAmount(vatamt,vatexpamt){
    let vatAmount, vatExemptedAmt,vatDisplayAmount;
    vatAmount = (vatamt && vatamt!='') ? parseFloat(vatamt) : 0;
    vatExemptedAmt = (vatexpamt && vatexpamt!='') ? parseFloat(vatexpamt) : 0;
    vatDisplayAmount = vatAmount - vatExemptedAmt;
    vatDisplayAmount = vatDisplayAmount.toString();
    return vatDisplayAmount;
  }

  	private handlePackageNavigation() {
		let selectedPackage = null;
		let serviceToBook = null
		let subServicesForAppointmentBooking = null
		let modeOfService: PACKAGELOCATION = this.viewAppointment.appointmentType == 'HC' ? 'HOMECARE' : 'CLINIC'
		try {
			let packageInfo = this.viewAppointment.packageInfo?.packageDetails
			let directiveCode = packageInfo?.directiveCode || packageInfo?.packageDirectiveCode
			let conceptCode = packageInfo?.conceptCode || packageInfo?.packageConceptCode
			let allPackageConcepts = this.user.getAllDirectives();
      console.log('packageInfo', packageInfo, 'directiveCode', directiveCode, 'conceptCode', conceptCode, 'allPackageConcepts', allPackageConcepts)
			selectedPackage = this.user.findConcept(allPackageConcepts, { directiveCode: directiveCode, conceptCode: conceptCode })
			console.log('selectedPackage', selectedPackage)
      if (modeOfService === 'HOMECARE') {
				let includedServicesInMainPackage = this.viewAppointment.packageInfo?.packageObject?.packageDtls?.servicesApplicable
				let bookedServicesInAppointment = (packageInfo?.serviceToBook || []).map(s => s.code)
				let bookedServiceFromMainPackage = includedServicesInMainPackage.filter(s => bookedServicesInAppointment.includes(s.conceptCode))
				serviceToBook = bookedServiceFromMainPackage[0];
			} else {
				serviceToBook = packageInfo?.serviceToBook?.[0]
			}
			subServicesForAppointmentBooking = packageInfo?.subServicesForAppointmentBooking?.[0]
		} catch (e) {
			// return this.showRescheduleAlert();
		}
		// if (!selectedPackage) return this.showRescheduleAlert();
		let packagesForAppointment = null
		try {
			let packageUtilisation = this.viewAppointment.subscribedPackageData
			let packageServDtls = packageUtilisation?.packageServDtls
			packagesForAppointment = packageServDtls.filter(pack => pack && pack.apptRef === this.viewAppointment.appointmentId)
		} catch (e) {

		}
		let includedServices = selectedPackage?.packageDtls?.servicesApplicable
		let firstIncludedService = serviceToBook || subServicesForAppointmentBooking
		let firstService = includedServices.find(ser => {
			return ser.conceptCode === (firstIncludedService.conceptCode || firstIncludedService.serviceCode)
		})
		let { concept, applicableFacilities } = this.user.getGroupedConcepts(firstService, includedServices)
		let facility = applicableFacilities.find(fac => fac.facilityId === this.viewAppointment.facilityId)
		let patient = this.user.getPatientByPatientId(this.viewAppointment.uhid, null)
		let careElementType = concept?.[0]?.careElementType
		const selectedAppointment = _.cloneDeep(this.viewAppointment)
		if (selectedAppointment['homeCareServices'] && selectedAppointment['homeCareServices']['serviceDetails'] && selectedAppointment['homeCareServices']['serviceDetails'].length > 0) {
			selectedAppointment['services'] = selectedAppointment['homeCareServices']['serviceDetails']
			selectedAppointment.serviceCategory = selectedAppointment['homeCareServices'].serviceGroup.name
			selectedAppointment['homeCareApptDtl'] = selectedAppointment['homeCareServices']
			if (selectedAppointment['services']) {
				selectedAppointment['services'].map(ele => {
					ele.selected = true
					ele['showAllButton'] = true
				})
			}
		}

		const state = {
			selectedDirective: selectedPackage._directiveRef,
			selectedPackage: selectedPackage,
			selectedFacilityId: selectedAppointment.facilityId,
			choosenFacility: facility,
			selectedPatient: patient,
			bookingForConcepts: concept,
			selectedVisitType: modeOfService,
			packageIndicator: 'ORDERSET',
			bookingApplicableFacilities: facility ? [facility] : [],
			subServicesForAppointmentBooking: subServicesForAppointmentBooking ? packagesForAppointment : null,
			isBookingSubService: subServicesForAppointmentBooking ? true : false,
			reschedule: true,
			toReschedule: selectedAppointment,
			careElementParams: {
				careElementType: careElementType,
				consultationType: selectedAppointment.appointmentType
			},
			consultationSelections: careElementType === 'CON' ? this.genConsultationSelections(selectedAppointment) : null
		}

    let careElementParams = {
				careElementType: careElementType,
				consultationType: selectedAppointment.appointmentType
			}

    this.packageService.setValue('selectedDirective', selectedPackage._directiveRef);
    this.packageService.setValue('selectedPackage', selectedPackage);
    this.packageService.setValue('selectedFacilityId', selectedAppointment.facilityId);
    this.packageService.setValue('choosenFacility', facility);
    this.packageService.setValue('selectedPatient', patient);
    this.packageService.setValue('bookingForConcepts', concept);
    this.packageService.setValue('visitType', modeOfService);
    this.packageService.setValue('packageIndicator', 'ORDERSET');
    this.packageService.setValue('bookingApplicableFacilities', facility ? [facility] : []);
    this.packageService.setValue('subServicesForAppointmentBooking', subServicesForAppointmentBooking ? packagesForAppointment : null);
    this.packageService.setValue('isBookingSubService', subServicesForAppointmentBooking ? true : false);
    this.packageService.setValue('reschedule', true);
    this.packageService.setValue('toReschedule', selectedAppointment);
    this.packageService.setValue('careElementParams', careElementParams);
    this.packageService.setValue('consultationSelections', careElementType === 'CON' ? this.genConsultationSelections(selectedAppointment) : null);
    this.packageService.setValue('flowType','HEALTHPKG');
    console.log('state///', state);
		if (this.viewAppointment.packageInfo?.modeOfService === 'CLINIC') {
      this.openSlotView();
      console.log('openHealthPackageSlot', this.openHealthPackageSlot);
		} else {
			//homecare flow
		}
	}

	private genConsultationSelections(selectedAppointment) {
		return {
			appointmentType: selectedAppointment.appointmentType === 'VIDEO' ? 'VIDEO' : 'HOSPITAL',
			selectedPractitioner: selectedAppointment.resourceId
		}
	}

  public checkAction(event?){
    if(event === 'BACK') {
      this.openSlotView()
    } else if(event === 'CLOSE') {
      this.openHealthPackageSlot = false;
      this.openPackageRescheduleConfirmReq = false;
    } else
    this.openHealthPackageSlot = false;
  }

  public setSlot(event){
    this.healthPkg = this.packageService.getAllHpValues();
    this.selectedNewSlot = event;
    this.generateConfirmReqParams();
  }

    
  public generateConfirmReqParams(){
    this.requestInfo = {
      "appointmentType": "HP",
      "flowType": this.healthPkg['flowType'],
      "visitType": this.healthPkg['visitType'],
      "selectedVisitType": this.healthPkg['visitType'],
      "selectedPkg": this.healthPkg['selectedPackage'],
      "selectedFacility": this.healthPkg['choosenFacility'],
      "selectedSlot": this.selectedNewSlot,
      "selectedPatient": this.healthPkg['selectedPatient'],
      "selectedDirective": this.healthPkg['selectedDirective'],
      "reschedule": this.healthPkg['reschedule']
    }
    this.packageService.setValue('canPay', false);
    this.openConfirmView();
    console.log("==== requestInfo =====", this.requestInfo)
  }


  public pkgConfirm(event) {
    console.log('pkgConfirm', event);
    this.apptConfirmDetails = event.data;
    this.openPackageConfirmationDtl()
  }

  public openSlotView() {
    this.currentView = 'SLOT';
    this.openHealthPackageSlot = true;
    this.openPackageRescheduleConfirmReq = false;
  }

  public openConfirmView() {
    this.currentView = "CONFIRMREQ";
    this.openHealthPackageSlot = false;
    this.openPackageRescheduleConfirmReq = true;
  }

  public openPackageConfirmationDtl() {
    this.currentView = "CONFIRM";
    this.openPackageRescheduleConfirmReq = false;
    this.openPackageResheduleConfirmationDtl = true;
  }

  public redirectToMyPackage(event) {
    // this.action.emit(event)
  }

  public backToHome() {
    this.packageService.clearAllValues();
    this.router.navigate([`${this.user.getPortalBasePath()}/home`])
  }

  public postProcess() {
    if(this.viewAppointment) {
      if (this.viewAppointment.chargeDetails) {
        this.calculatePayable()
        this.computedDetail = this.getComputedCodeDetail();
        this.apptDetail = {}
      }
      if(this.viewAppointment['bookedType'] == 'HOMECARE'){
        this.totalCost();
      }
      let headerType = 'CLINIC';
      let uiHeaderType = null
      switch (this.viewAppointment.appointmentType) {
        case 'VIDEO':
          headerType = this.viewAppointment.isOnspot ? 'ONSPOT' : 'VIDEO';
          break;
        case 'HC':
          headerType = 'HC';
          uiHeaderType = 'HC'
          if (this.viewAppointment.isPackage) uiHeaderType = 'HLTHPKGHC'
          break;
        default:
          headerType = 'CLINIC'
          if (this.viewAppointment.expressClinicLocationDtl) headerType = 'EXPRESS'
          if (this.viewAppointment.isPackage) {
            headerType = 'HLTHPKG';
            uiHeaderType = 'HLTHPKGCLINIC'
            this.viewAppointment._isPackageAppointment = true;
            this.viewAppointment._isConsultationPackage = this.viewAppointment.packageInfo?.packageDetails?.packageCategory === 'CON'
          }
      }

      this.viewAppointment['_headerType'] = headerType;
      this.viewAppointment['_uiHeaderType'] = uiHeaderType;
      if(this.viewAppointment.isPackage){
        let packages = _.cloneDeep(this.user.getDirectiveByDirectiveGroup('HEALTHPACKAGES'))
        let concepts = (packages || []).map(p => p.concepts).flat();
        let concept = concepts.find(pac => pac.code == this.viewAppointment['packageInfo']['packageCode'])
        if (concept) {
          this.viewAppointment['packageInfo']['packageObject'] = _.cloneDeep(concept)
        }
      } 
      this.disablePayBeforeCheckinTime = (this.viewAppointment.appointmentType !== 'VIDEO' && this.viewAppointment.checkInAllowed == 'true') ? this.user.canViewOption('DISABLEPAYBEFORECHECKINTIME') : false;
      // this.promoCodeParams = this.getpromoCodeParam()
      if(this.viewAppointment?.['homeCareServices']?.['amount'])
        this.viewAppointment['homeCareServices']['amount'] = this.user.fixDecimalPlaces(this.viewAppointment['homeCareServices']['amount']);
      this.viewAppointment['_showAppointmentStatus'] = this.showAppointemntStatus(this.viewAppointment);
      console.log('viewAppointment', this.viewAppointment);
    }
  }

  public showAppointemntStatus(selectedAppt){
    let apptStatus = false
    if( selectedAppt && selectedAppt['_headerType']!='HLTHPKG' && selectedAppt['recurringYn'] !== 'Y'|| selectedAppt['isSubAppt']){
        apptStatus = true;
      if(selectedAppt['isPackage'] &&  selectedAppt['homeCareServices'] && selectedAppt['homeCareServices']['packageDetails'] && (selectedAppt['homeCareServices']['packageDetails']['subServicesForAppointmentBooking'] && selectedAppt['homeCareServices']['packageDetails']['subServicesForAppointmentBooking'].length >= 0))
        apptStatus = false;
    }else{
      apptStatus = false
    }
    return apptStatus;
  }

  public totalCost() {
    if(this.viewAppointment['homeCareServices'] && this.viewAppointment['homeCareServices'].length > 0){
      let total = this.viewAppointment['homeCareServices'].filter((s) => s.selected).reduce((c, a) => {
        c += Number(a.details.servicecost);
        return c;
      }, 0);
      this.totalServiceCost = this.user.fixDecimalPlaces(total);
      return this.user.fixDecimalPlaces(total);
    }
  }

    public getComputedCodeDetail() {
    let computedDetail = {
      loading: false,
      //charge always equals netPayable from chargeDetails
      charge: this.viewAppointment?.chargeDetails?.netPayable || 0,
      patientPayable: this.viewAppointment?.chargeDetails?.netPayable || 0,
      //charge always equals netPayable from chargeDetails
      discountedPayable: this.viewAppointment?.chargeDetails?.discountedPayable,
      freeFollowUp: this.viewAppointment?.chargeDetails?.isFreeFollowUp ? 'Y' : 'N',
      billingGroupCode: this.viewAppointment?.chargeDetails?.billingGroupCode || 'CASH',
      paid: false,
      additionalChargeDetails: {
          actualCharge: this.viewAppointment?.chargeDetails?.['consultationFee'],
          totalCharge: this.viewAppointment?.chargeDetails?.['totalAmount'],
          payableCharge: this.viewAppointment?.chargeDetails?.['netPayable']
      },
      promoDetails: this.viewAppointment?.chargeDetails?.discountDetails,
      promoCodeParams: {
        selectedPractitioner: this.viewAppointment?.['resourceId'],
        selectedSpeciality: this.viewAppointment?.['specialityCode'],
        selectedFacility: {
          facilityId: this.viewAppointment?.['facilityId']
        },
        selectedPatient: {
          patientId: this.viewAppointment?.['patientId']
        }
      },
      chargeVatDetails: this.viewAppointment?.chargeDetails?.parsedCharge,

      coupon_or_discount: {
      netPayable: this.viewAppointment?.chargeDetails?.netPayable || 0,
      discountedPayable: this.viewAppointment?.chargeDetails?.netPayable || 0
      },
      isPromoApplied: this.viewAppointment?.chargeDetails?.isPromoApplied || false,
      isPointsApplied: this.viewAppointment?.chargeDetails?.isPointsApplied || false,
      isCouponApplied: this.viewAppointment?.chargeDetails?.isCouponApplied || false,
      display: {
        cc: this.viewAppointment?.chargeDetails?.parsedCharge?.baseServiceAmount,
        vat: this.viewAppointment?.chargeDetails?.parsedCharge?.vatDisplayAmount || 0,
        promo: this.viewAppointment?.chargeDetails?.promoDiscount || 0,
        points: this.viewAppointment?.chargeDetails?.pointsDiscount || 0,
        coupon: this.viewAppointment?.chargeDetails?.couponDiscount || 0,
        discountApplied: (this.viewAppointment?.chargeDetails?.promoDiscount || this.viewAppointment?.chargeDetails?.pointsDiscount) ? 'Y': 'N',
        discountedPayable: Number(this.viewAppointment?.chargeDetails?.discountedPayable),
        payable: this.viewAppointment?.chargeDetails?.netPayable
      }
    }
    return computedDetail
  }


  public applyingAltPayment(event) {
    // this.setIsApplyingCode(event.status)
  }
  
  public appliedAltPayment(event) {
    console.log('appliedAltPayment', event);
    if (event.computedDetail) {
      this.computedDetail = event.computedDetail;
    }
    if (event.chargeDetails) {
      this.viewAppointment.chargeDetails = event.chargeDetails;
    }
    if (event.apptDetail) {
      // Handle appointment details if needed
      // this.viewAppointment = { ...this.viewAppointment, ...event.apptDetail };
      this.apptDetail = event.apptDetail;
    }
    let couponDiscount = this.viewAppointment.chargeDetails.couponDiscount || 0;
    let pointsDiscount = this.pointsType == 'PAYMENT' ? (this.viewAppointment.chargeDetails.pointsDiscount || 0) : 0;
    this.viewAppointment.chargeDetails.netPayable = this.viewAppointment.chargeDetails.discountedPayable - couponDiscount - pointsDiscount;
    this.viewAppointment.chargeDetails._payableWithoutCoupon = this.viewAppointment.chargeDetails.netPayable + couponDiscount;
    this.viewAppointment.chargeDetails._payableWithoutPoints = this.viewAppointment.chargeDetails.netPayable + pointsDiscount;
    console.log('appliedAltPayment', this.viewAppointment);
    // this.calculatePayable();
  }


}
